import { FrenchCommune, Territory } from "@typings/globals";

import {
  SelectOption,
  SelectOptionCustom,
} from "@ui/Atoms/Form/SelectExtended";

import { capitalize } from "@services/Capitalize";

import { TranslateFunction } from "@hooks/useTranslate";

const getGenderOptions = (translate: TranslateFunction): SelectOption[] => [
  { value: "male", label: translate("male") },
  { value: "female", label: translate("female") },
];

const getCommuneOptions = (communes: FrenchCommune[]): SelectOptionCustom[] =>
  communes.map(commune => ({
    value: commune.inseeCode,
    label: capitalize(commune.communeName),
    extraLabel: capitalize(`${commune.departmentName} ${commune.inseeCode}`),
  }));

const getCountryOptions = (countries: Territory[]): SelectOption[] =>
  countries.map(country => ({
    value: country.inseeCode,
    label: capitalize(country.name),
  }));

export { getGenderOptions, getCommuneOptions, getCountryOptions };
